import { Box, Card, InputAdornment, Popover, Stack, TextField } from '@mui/material';
import { FieldProps } from 'formik';
import { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
const palette: string[] = [
  '#F44336', // Red 500
  '#E91E63', // Pink 500
  '#9C27B0', // Purple 500
  '#673AB7', // Deep Purple 500
  '#3F51B5', // Indigo 500

  '#2196F3', // Blue 500
  '#03A9F4', // Light Blue 500
  '#00BCD4', // Cyan 500
  '#009688', // Teal 500
  '#4CAF50', // Green 500

  '#8BC34A', // Light Green 500
  '#CDDC39', // Lime 500
  '#FFEB3B', // Yellow 500
  '#FFC107', // Amber 500
  '#FF9800', // Orange 500

  '#FF5722', // Deep Orange 500
  '#795548', // Brown 500
  '#9E9E9E', // Grey 500
  '#607D8B', // Blue Grey 500
  '#B39DDB', // Deep Purple 200 (soft)

  '#90CAF9', // Blue 200 (soft)
  '#80CBC4', // Teal 200 (soft)
  '#A5D6A7', // Green 200 (soft)
  '#FFF59D', // Yellow 200 (soft)
  '#FFAB91' // Deep Orange 200 (soft)
];
type ColorPickerProps = {
  presetColors?: string[];
};
export const ColorPickerField = ({
  field,
  form,
  presetColors = palette,
  ...props
}: FieldProps & ColorPickerProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  const handleChange = (color: string) => {
    form.setFieldValue(field.name, color);
  };

  return (
    <>
      <TextField
        {...field}
        {...props}
        disabled
        value={field.value || ''}
        onClick={handleOpen}
        InputProps={{
          readOnly: true,
          startAdornment: (
            <InputAdornment position="start">
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  bgcolor: field.value || '#cbcbcb',
                  border: '1px solid #ccc',
                  borderRadius: '2px'
                }}
              />
            </InputAdornment>
          )
        }}
      />

      <Popover
        draggable={false}
        onDrag={() => {}}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Card sx={{ p: 2 }}>
          <Stack spacing={1} direction="column">
            <Box
              onMouseDown={(e) => e.stopPropagation()}
            >
              <HexColorPicker
                color={field.value || '#cbcbcb'}
                onChange={handleChange}
              />
            </Box>

            <Stack direction="row" flexWrap="wrap" gap={0.5} maxWidth={200}>
              {presetColors.map((c) => (
                <Box
                  key={c}
                  onClick={() => handleChange(c)}
                  onMouseDown={(e) => e.stopPropagation()}
                  sx={{
                    width: 20,
                    height: 20,
                    bgcolor: c,
                    cursor: 'pointer',
                    border: '1px solid #ccc'
                  }}
                />
              ))}
            </Stack>
          </Stack>
        </Card>
      </Popover>
    </>
  );
};
